(function (root) {
  'use strict';

  function createPlayer({ video, surface, sound, fullscreen, poster, status, source, onFullscreen }) {
    let active = false;
    let position = 0;
    const label = video.getAttribute('aria-label') || 'Vidéo';
    video.tabIndex = 0;
    video.setAttribute('role', 'button');
    video.muted = true;
    video.defaultMuted = true;
    function sync() {
      video.setAttribute('aria-label', label + (video.paused ? ' — Lire la vidéo' : ' — Mettre la vidéo en pause'));
      video.setAttribute('aria-pressed', String(!video.paused));
      sound.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M11 5 6 9H3v6h3l5 4V5Z"/>' + (video.muted ? '<path d="m16 9 5 6m0-6-5 6"/>' : '<path d="M15 8a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14"/>') + '</svg>';
      sound.setAttribute('aria-label', video.muted ? 'Activer le son' : 'Couper le son');
      sound.setAttribute('aria-pressed', String(!video.muted));
    }
    function start() {
      const pending = video.play();
      if (pending && pending.catch) pending.catch(() => { sync(); });
    }
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('volumechange', sync);
    video.addEventListener('playing', () => { poster.hidden = true; status.hidden = true; });
    video.addEventListener('loadedmetadata', () => {
      if (active && position) video.currentTime = Math.min(position, Number.isFinite(video.duration) ? Math.max(0, video.duration - 0.1) : position);
    });
    video.addEventListener('error', () => {
      if (!active) return;
      status.textContent = 'La vidéo ne peut pas être chargée. Touchez la vidéo pour réessayer.';
      status.hidden = false;
    });
    function activate({ time } = {}) {
      if (active) return;
      active = true;
      if (Number.isFinite(time)) position = time;
      video.muted = true;
      video.setAttribute('src', source());
      video.load();
      start();
      sync();
    }
    function deactivate() {
      if (!active) return;
      active = false;
      position = video.currentTime || position;
      video.pause();
      video.muted = true;
      video.removeAttribute('src');
      video.load();
      poster.hidden = false;
      sync();
    }
    function toggle() {
      if (!active) return;
      if (video.paused) start();
      else video.pause();
    }
    surface.addEventListener('click', event => {
      if (event.target.closest && event.target.closest('button')) return;
      toggle();
    });
    video.addEventListener('keydown', event => {
      if (event.key !== ' ' && event.key !== 'Enter') return;
      event.preventDefault();
      toggle();
    });
    sound.addEventListener('click', event => { event.stopPropagation(); if (active) { video.muted = !video.muted; sync(); } });
    fullscreen.addEventListener('click', event => { event.stopPropagation(); onFullscreen(); });
    sync();
    return { activate, deactivate, get position() { return active ? video.currentTime : position; }, get active() { return active; } };
  }

  function mount({ page, gallery, gallerySlides, galleryIndex, lightbox, lightboxTrack, setLightbox }) {
    const slide = gallery.querySelector('[data-anne-video]');
    if (!slide) return;
    const index = gallerySlides.indexOf(slide);
    const modalSlide = lightboxTrack.children[index];
    const mobile = root.matchMedia('(max-width: 749px), (hover: none) and (pointer: coarse)');
    const doc = page.ownerDocument;
    let inView = !root.IntersectionObserver;
    let opener;
    function makePlayer(container, portrait, onFullscreen) {
      const poster = container.querySelector('img');
      const frame = doc.createElement('div');
      frame.className = 'sm-anne-player';
      const video = doc.createElement('video');
      video.preload = 'none';
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('muted', '');
      video.setAttribute('aria-label', slide.dataset.videoLabel);
      video.disablePictureInPicture = true;
      const controls = doc.createElement('div');
      controls.className = 'sm-anne-controls';
      function button(label, text) {
        const node = doc.createElement('button');
        node.type = 'button'; node.setAttribute('aria-label', label); node.textContent = text;
        controls.append(node); return node;
      }
      const sound = button('Activer le son', '');
      sound.hidden = slide.dataset.hasAudio === 'false';if (sound.hidden) sound.style.display = 'none';
      sound.className = 'sm-anne-sound';
      const fullscreen = button(portrait ? 'Plein écran' : 'Agrandir la vidéo', '⛶');
      fullscreen.className = 'sm-anne-expand';
      const status = doc.createElement('p');
      status.className = 'sm-anne-status'; status.setAttribute('role', 'status'); status.hidden = true;
      frame.append(poster, video, controls, status);
      container.replaceChildren(frame);
      return { ...createPlayer({ video, surface: frame, sound, fullscreen, poster, status,
        source: () => portrait && mobile.matches ? slide.dataset.portraitUrl : slide.dataset.squareUrl,
        onFullscreen: () => onFullscreen(fullscreen)
      }), video, fullscreen };
    }
    // Each view owns one connection; changing views always pauses and starts muted.
    const inline = makePlayer(slide, false, button => {
      opener = button;
      const time = inline.video.currentTime;
      inline.deactivate();
      lightbox.showModal();
      modal.activate({ time });
      setLightbox(index);
      lightbox.querySelector('[data-close]').focus({ preventScroll: true });
    });
    const modal = makePlayer(modalSlide, true, () => {
      // Keep the custom player and its speaker control on browsers without container fullscreen.
      if (lightbox.requestFullscreen && !doc.fullscreenElement) {
        const pending = lightbox.requestFullscreen();
        if (pending && pending.catch) pending.catch(() => {});
      }
    });
    modalSlide.classList.add('sm-anne-fullscreen-slide');
    function sync() {
      const visible = doc.visibilityState !== 'hidden';
      const modalActive = lightbox.open && Math.round(lightboxTrack.scrollLeft / (lightboxTrack.clientWidth || 1)) === index;
      if (slide.dataset.mobileCover === 'true') lightbox.toggleAttribute('data-video-fullscreen', modalActive);
      if (visible && modalActive) { inline.deactivate(); modal.activate(); }
      else {
        modal.deactivate();
        if (visible && inView && !lightbox.open && galleryIndex() === index) inline.activate();
        else inline.deactivate();
      }
    }
    gallery.addEventListener('scroll', sync, { passive: true });
    lightboxTrack.addEventListener('scroll', sync, { passive: true });
    lightbox.addEventListener('close', () => {
      modal.deactivate();
      if (doc.fullscreenElement === lightbox && doc.exitFullscreen) doc.exitFullscreen().catch(() => {});
      if (opener) { opener.focus({ preventScroll: true }); opener = null; }
      sync();
    });
    lightbox.addEventListener('cancel', () => modal.deactivate());
    doc.addEventListener('visibilitychange', sync);
    new root.MutationObserver(sync).observe(lightbox, { attributes: true, attributeFilter: ['open'] });
    if (root.IntersectionObserver) new root.IntersectionObserver(entries => {
      inView = entries.some(entry => entry.isIntersecting);
      sync();
    }, { threshold: 0.1 }).observe(gallery);
    mobile.addEventListener('change', () => {
      if (lightbox.open && Math.round(lightboxTrack.scrollLeft / (lightboxTrack.clientWidth || 1)) === index && modal.video.hasAttribute('src')) {
        const time = modal.video.currentTime;
        modal.deactivate();
        modal.activate({ time });
      }
      sync();
    });
    sync();
  }

  const api = { createPlayer, mount };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.LpcAnneVideo = api;
})(typeof window !== 'undefined' ? window : globalThis);
